export default __webpack_public_path__ + "static/media/pilz-07.3dcbcedb.png";